@if (changes && changes.length > 0) {
  <div class="orange">Vær opmærksom på ændrede aftalevilkår vedr. abn. eller tilvalg</div>
}
